<template>
    <v-app v-if="loaded" id="inspire" class="reports-and-summaries">
        <v-snackbar
            v-model="snackbarFoundArticles"
            timeout="6000"
            multi-line
            top
            left
            color="green"
        >
            {{ $t("messages.foundArticles") }}
            {{ countOfFoundArticles() }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    icon
                    dark
                    v-bind="attrs"
                    @click="snackbarFoundArticles = !snackbarFoundArticles"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-app-bar
            v-if="screen === 'mobile'"
            app
            color="#2196F3"
            dark
            clipped-left
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            <div class="fill-width align-center fill-height d-flex">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            class="d-flex align-center"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-tooltip bottom z-index="10">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        icon
                                        @click="
                                            showElements.showSearch = !showElements.showSearch;
                                            showElements.showReloader = !showElements.showReloader;
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t("tooltips.search") }}</span>
                            </v-tooltip>
                            <v-form
                                @submit.prevent="searchSubmit"
                                class="search"
                            >
                                <div
                                    v-if="showElements.showSearch"
                                    class="d-flex align-center mr-3"
                                >
                                    <v-text-field
                                        placeholder="Поиск"
                                        class="search_input mt-3"
                                        autofocus
                                        clearable
                                        v-model="searchValue"
                                    />
                                </div>
                            </v-form>
                        </div>
                    </template>
                    <div class="date__menu-wrapper d-flex flex-wrap pa-5">
                        <v-tooltip bottom z-index="10">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    @click="
                                        showElements.showDate = !showElements.showDate
                                    "
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-calendar</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="!showElements.showDate">{{
                                $t("tooltips.open_date")
                            }}</span>
                            <span v-else>{{ $t("tooltips.close_date") }}</span>
                        </v-tooltip>
                        <v-menu
                            v-model="showElements.showDateMenu"
                            transition="slide-y-transition"
                            :close-on-content-click="false"
                            offset-y
                            bottom
                        >
                            <template v-slot:activator="{ attrs, on }">
                                <v-text-field
                                    v-model="getDateRangeText"
                                    :label="$t('labels.date')"
                                    placeholder="Дата"
                                    class="date input-date"
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    append-outer-icon="mdi-close"
                                    @click:append-outer="
                                        currentDate.dateRangeText =
                                            currentDate.today
                                    "
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="currentDate.dateRangeText"
                                locale="ru-RU"
                                range
                                @change="showElements.showDateMenu = false"
                            ></v-date-picker>
                        </v-menu>
                        <div class="input-div" v-if="showElements.showDate">
                            <div class="d-flex align-center">
                                <div class="time__area d-flex">
                                    <v-tooltip bottom z-index="10">
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="
                                                    showElements.showTime = !showElements.showTime
                                                "
                                            >
                                                <v-icon>mdi-av-timer</v-icon>
                                            </v-btn>
                                        </template>
                                        <span v-if="!showElements.showTime">{{
                                            $t("tooltips.open_time")
                                        }}</span>
                                        <span v-else>{{
                                            $t("tooltips.close_time")
                                        }}</span>
                                    </v-tooltip>
                                    <v-text-field
                                        v-if="showElements.showTime"
                                        type="time"
                                        :label="$t('labels.time_start')"
                                        v-model="currentDate.firstTime"
                                        class="mr-2 firstTime"
                                        max-width="40px"
                                    ></v-text-field>
                                    <v-text-field
                                        v-if="showElements.showTime"
                                        max-width="40px"
                                        :label="$t('labels.time_end')"
                                        v-model="currentDate.lastTime"
                                        class="lastTime"
                                        type="time"
                                        append-outer-icon="mdi-close"
                                        @click:append-outer="
                                            (currentDate.firstTime = '00:00'),
                                                (currentDate.lastTime = '23:59')
                                        "
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                        <v-tooltip bottom z-index="10">
                            <template v-slot:activator="{ on, attrs }">
                                <button
                                    class="btn btn--fill d-flex justify-center mt-2"
                                    style="width: 100%"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="searchSubmit"
                                    dark
                                    color="#2196F3"
                                >
                                    <span>
                                        {{ $t("tooltips.search") }}
                                    </span>
                                </button>
                            </template>
                            <span>{{ $t("tooltips.search_action") }}</span>
                        </v-tooltip>
                    </div>
                </v-menu>

                <v-tooltip v-if="showElements.showReloader" bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-reload</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.reload") }}</span>
                </v-tooltip>
                <v-spacer />
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn btn--download mr-3"
                            v-bind="attrs"
                            style="display: flex; align-items: center"
                            v-on="on"
                            @click="openDownloadPopup"
                        >
                            <span class="btn__icon">
                                <svg
                                    width="17"
                                    height="20"
                                    fill="#fff"
                                    viewBox="0 0 17 20"
                                >
                                    <use xlink:href="#download-icon" />
                                </svg>
                            </span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.download") }}</span>
                </v-tooltip>
                <v-select
                    :items="langs"
                    v-model="currentLang"
                    item-value="key"
                    item-text="label"
                    class="mt-2 select--lang"
                    style="max-width: 45px"
                >
                    <template slot="selection" slot-scope="{ item }">
                        <span>{{ item.key }}</span>
                    </template>
                    <template slot="item" slot-scope="{ item }">
                        <span>{{ item.key }}</span>
                    </template>
                </v-select>
            </div>
        </v-app-bar>
        <v-app-bar
            v-if="screen === 'desktop'"
            app
            color="#2196F3"
            dark
            clipped-left
        >
            <div class="fill-width align-center fill-height d-flex">
                <div class="d-flex align-center">
                    <v-select
                        :items="langs"
                        v-model="currentLang"
                        item-value="key"
                        item-text="label"
                        class="mt-2 select--lang"
                        style="max-width: 45px"
                    >
                        <template slot="selection" slot-scope="{ item }">
                            <span>{{ item.key }}</span>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                            <span>{{ item.key }}</span>
                        </template>
                    </v-select>
                    <v-tooltip bottom z-index="10">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                class="ml-1"
                                @click="
                                    showElements.showSearch = !showElements.showSearch;
                                    showElements.showReloader = !showElements.showReloader;
                                "
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t("tooltips.search") }}</span>
                    </v-tooltip>
                    <v-form @submit.prevent="searchSubmit" class="search">
                        <div
                            v-if="showElements.showSearch"
                            class="d-flex align-center mr-1"
                        >
                            <v-text-field
                                placeholder="Поиск"
                                class="search_input mt-2"
                                autofocus
                                clearable
                                v-model="searchValue"
                            />
                            <v-tooltip bottom z-index="10">
                                <template v-slot:activator="{ on, attrs }">
                                    <button
                                        class="btn btn--round"
                                        v-bind="attrs"
                                        v-on="on"
                                        dark
                                        color="#2196F3"
                                    >
                                        <v-icon> mdi-clipboard-search </v-icon>
                                    </button>
                                </template>
                                <span>{{ $t("tooltips.search_action") }}</span>
                            </v-tooltip>
                        </div>
                    </v-form>
                </div>
                <v-divider class="mr-1 ml-1" vertical></v-divider>
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            @click="
                                showElements.showDate = !showElements.showDate
                            "
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>mdi-calendar</v-icon>
                        </v-btn>
                    </template>
                    <span v-if="!showElements.showDate">{{
                        $t("tooltips.open_date")
                    }}</span>
                    <span v-else>{{ $t("tooltips.close_date") }}</span>
                </v-tooltip>
                <div class="input-div" v-if="showElements.showDate">
                    <div class="d-flex align-center">
                        <v-menu
                            v-model="showElements.showDateMenu"
                            transition="slide-y-transition"
                            :close-on-content-click="false"
                            offset-y
                            bottom
                        >
                            <template v-slot:activator="{ attrs, on }">
                                <v-text-field
                                    v-model="getDateRangeText"
                                    :label="$t('labels.date')"
                                    placeholder="Дата"
                                    class="mt-8 date input-date"
                                    v-bind="attrs"
                                    v-on="on"
                                    readonly
                                    append-outer-icon="mdi-close"
                                    @click:append-outer="
                                        currentDate.dateRangeText =
                                            currentDate.today
                                    "
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="currentDate.dateRangeText"
                                locale="ru-RU"
                                range
                                @change="showElements.showDateMenu = false"
                            ></v-date-picker>
                        </v-menu>
                        <v-divider class="mr-1 ml-1" vertical></v-divider>
                        <v-tooltip bottom z-index="10">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="
                                        showElements.showTime = !showElements.showTime
                                    "
                                >
                                    <v-icon>mdi-av-timer</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="!showElements.showTime">{{
                                $t("tooltips.open_time")
                            }}</span>
                            <span v-else>{{ $t("tooltips.close_time") }}</span>
                        </v-tooltip>
                        <v-text-field
                            v-if="showElements.showTime"
                            type="time"
                            :label="$t('labels.time_start')"
                            v-model="currentDate.firstTime"
                            class="mt-8 mr-1 firstTime"
                            max-width="40px"
                        ></v-text-field>
                        <v-text-field
                            v-if="showElements.showTime"
                            max-width="40px"
                            :label="$t('labels.time_end')"
                            v-model="currentDate.lastTime"
                            class="mt-8 lastTime"
                            type="time"
                            append-outer-icon="mdi-close"
                            @click:append-outer="
                                (currentDate.firstTime = '00:00'),
                                    (currentDate.lastTime = '23:59')
                            "
                        ></v-text-field>
                    </div>
                </div>

                <v-divider class="mr-1 ml-1" vertical></v-divider>
                <v-tooltip
                    bottom
                    z-index="10"
                    v-if="
                        activeReport.length && activeReport[0].type === 'report'
                    "
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="openAddReportsPopup"
                        >
                            <span class="btn__icon">
                                <svg
                                    width="44"
                                    height="44"
                                    fill="none"
                                    viewBox="0 0 44 44"
                                >
                                    <use xlink:href="#add-reports-icon" />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.addReport") }}</span>
                </v-tooltip>

                <v-divider
                    class="mr-1 ml-1"
                    vertical
                    v-if="
                        activeReport.length && activeReport[0].type === 'report'
                    "
                ></v-divider>
                <v-tooltip
                    bottom
                    z-index="10"
                    style="margin-left: 20px"
                    v-if="
                        activeReport.length && activeReport[0].type === 'report'
                    "
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="addNewsToReport"
                        >
                            <span class="btn__icon">
                                <svg width="44" height="44" viewbox="0 0 44 44">
                                    <use
                                        xlink:href="#add-news-to-report-icon"
                                    />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.addToReport") }}</span>
                </v-tooltip>
                <v-divider
                    class="mr-1 ml-1"
                    vertical
                    v-if="
                        activeReport.length && activeReport[0].type === 'report'
                    "
                ></v-divider>
                <v-tooltip
                    bottom
                    z-index="10"
                    v-if="
                        activeReport.length && activeReport[0].type === 'report'
                    "
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="removeDocument"
                        >
                            <span class="btn__icon">
                                <svg
                                    width="44"
                                    height="44"
                                    fill="none"
                                    viewBox="0 0 44 44"
                                >
                                    <use xlink:href="#remove-document-icon" />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.removeDocumentFromReport") }}</span>
                </v-tooltip>
                <v-divider
                    class="mr-1 ml-1"
                    vertical
                    v-if="
                        activeReport.length && activeReport[0].type === 'report'
                    "
                ></v-divider>
                <v-tooltip bottom z-index="10" v-if="activeReport.length">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="renamePopup"
                        >
                            <span class="btn__icon">
                                <svg
                                    width="44"
                                    height="44"
                                    fill="none"
                                    viewBox="0 0 44 44"
                                >
                                    <use xlink:href="#rename-icon" />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span
                        v-if="
                            activeReport.length &&
                            activeReport[0].type === 'report'
                        "
                        >{{ $t("tooltips.renameReport") }}</span
                    >
                    <span
                        v-else-if="
                            activeReport.length &&
                            activeReport[0].type === 'summary'
                        "
                    >
                        {{ $t("tooltips.renameSummary") }}
                    </span>
                    <span v-else>{{ $t("messages.selectedItem") }}</span>
                </v-tooltip>
                <v-divider
                    class="mr-1 ml-1"
                    vertical
                    v-if="activeReport.length"
                ></v-divider>
                <v-tooltip bottom z-index="10" v-if="activeReport.length">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="openRemoveReportsPopup"
                        >
                            <span class="btn__icon">
                                <svg
                                    width="44"
                                    height="44"
                                    fill="none"
                                    viewBox="0 0 44 44"
                                >
                                    <use xlink:href="#remove-reports-icon" />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span
                        v-if="
                            activeReport.length &&
                            activeReport[0].type === 'report'
                        "
                        >{{ $t("tooltips.removeReport") }}</span
                    >
                    <span
                        v-else-if="
                            activeReport.length &&
                            activeReport[0].type === 'summary'
                        "
                    >
                        {{ $t("tooltips.removeSummary") }}
                    </span>
                </v-tooltip>
                <v-divider
                    class="mr-1 ml-1"
                    vertical
                    v-if="activeReport.length"
                ></v-divider>
                <v-tooltip
                    bottom
                    z-index="10"
                    v-if="
                        activeReport.length &&
                        activeReport[0].type === 'summary'
                    "
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="openAddSummariesPopup"
                        >
                            <span class="btn__icon">
                                <svg
                                    width="44"
                                    height="44"
                                    fill="none"
                                    viewBox="0 0 44 44"
                                >
                                    <use xlink:href="#add-summaries-icon" />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.addSummaries") }}</span>
                </v-tooltip>
                <v-divider
                    class="mr-1 ml-1"
                    vertical
                    bottom
                    z-index="10"
                    v-if="
                        activeReport.length &&
                        activeReport[0].type === 'summary'
                    "
                ></v-divider>
                <v-tooltip
                    bottom
                    z-index="10"
                    v-if="
                        activeReport.length &&
                        activeReport[0].type === 'summary'
                    "
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="saveSummaryOptions"
                        >
                            <span class="btn__icon">
                                <svg
                                    width="44"
                                    height="44"
                                    fill="none"
                                    viewBox="0 0 44 44"
                                >
                                    <use xlink:href="#save-summary-icon" />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ $t("tooltips.saveSummary") }}</span>
                </v-tooltip>
                <v-divider
                    class="mr-1 ml-1"
                    vertical
                    bottom
                    z-index="10"
                    v-if="
                        activeReport.length &&
                        activeReport[0].type === 'summary'
                    "
                ></v-divider>
                <v-tooltip
                    bottom
                    z-index="10"
                    v-if="
                        activeReport.length &&
                        activeReport[0].type === 'summary' &&
                        !activeReport[0].parent
                    "
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="
                                showElements.showSummaryTemplatePopUp = true
                            "
                        >
                            <span class="btn__icon">
                                <svg
                                    width="44"
                                    height="44"
                                    fill="none"
                                    viewBox="0 0 44 44"
                                >
                                    <use
                                        xlink:href="#save-summary-template-icon"
                                    />
                                </svg>
                            </span>
                        </v-btn>
                    </template>
                    <span>{{ $t("modals.savedSummaryTemplate.title") }}</span>
                </v-tooltip>
                <v-divider
                    class="mr-1 ml-1"
                    vertical
                    bottom
                    z-index="10"
                    v-if="
                        activeReport.length &&
                        activeReport[0].type === 'summary' &&
                        !activeReport[0].parent
                    "
                ></v-divider>
                <v-spacer />
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn btn--download mr-1"
                            v-bind="attrs"
                            style="display: flex; align-items: center"
                            v-on="on"
                            @click="openDownloadPopup"
                        >
                            <span class="btn__text">
                                {{ $t("buttons.download") }}
                            </span>
                            <span class="btn btn--stroke btn__icon">
                                <svg
                                    width="17"
                                    height="20"
                                    fill="#fff"
                                    viewBox="0 0 17 20"
                                >
                                    <use xlink:href="#download-icon" />
                                </svg>
                            </span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.download") }}</span>
                </v-tooltip>
                <v-divider class="mr-1 ml-1" vertical></v-divider>
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn pt-2 ml-1"
                            v-bind="attrs"
                            v-on="on"
                            @click="exit"
                        >
                            <span class="btn__text">
                                {{ $t("buttons.exit") }}
                            </span>
                            <span class="btn__icon">
                                <svg
                                    width="17"
                                    height="20"
                                    fill="#fff"
                                    viewBox="0 0 17 20"
                                >
                                    <use xlink:href="#exit-icon" />
                                </svg>
                            </span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.exit") }}</span>
                </v-tooltip>
            </div>
        </v-app-bar>
        <v-navigation-drawer
            v-if="screen === 'mobile'"
            v-model="drawer"
            :class="{ 'expansion-is-open': panelSettings.length }"
            app
            mobile-breakpoint="1280"
            class="nav-drawer"
        >
            <vue-custom-scrollbar
                class="scroll-area treeview__main-scroll"
                :settings="scrollbarSettings"
            >
            </vue-custom-scrollbar>
            <div class="drawer__footer pr-10">
                <v-tooltip bottom z-index="10">
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn pt-2 ml-auto"
                            v-bind="attrs"
                            v-on="on"
                            @click="exit"
                        >
                            <span class="btn__text">
                                {{ $t("buttons.exit") }}
                            </span>
                            <span class="btn__icon">
                                <svg
                                    width="17"
                                    height="20"
                                    fill="#757575"
                                    viewBox="0 0 17 20"
                                >
                                    <use xlink:href="#exit-icon" />
                                </svg>
                            </span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.exit") }}</span>
                </v-tooltip>
            </div>
        </v-navigation-drawer>
        <v-navigation-drawer
            v-if="screen === 'desktop'"
            v-model="drawer"
            app
            clipped
            mobile-breakpoint="1280"
            class="nav-drawer"
        >
            <vue-custom-scrollbar
                class="scroll-area"
                style="height: calc(100vh - 65px)"
                :settings="scrollbarSettings"
            >
                <v-toolbar dense class="links-wrap">
                    <v-btn :to="{ path: '/' }" class="home-btn link-btn">{{
                        $t("tooltips.news")
                    }}</v-btn>
                    <v-divider class="divider" vertical></v-divider>
                    <v-btn
                        :to="{ path: '/reports' }"
                        class="report-btn link-btn"
                    >
                        {{ $t("tooltips.reportAndSummary") }}</v-btn
                    >
                </v-toolbar>
                <reports-menu
                    v-on:fetchDocuments="fetchDocuments"
                    ref="repMenu"
                />
            </vue-custom-scrollbar>
        </v-navigation-drawer>
        <v-main
            :style="
                this.activeReport.length
                    ? ''
                    : 'display: flex; align-items: center;'
            "
        >
            <v-container
                class="reports"
                fluid
                outlined
                tile
                v-if="this.activeReport.length"
            >
                <v-overlay
                    v-if="tableLoading"
                    absolute
                    :opacity="0.5"
                    z-index="100000"
                >
                    <v-progress-circular indeterminate size="100">
                        {{ $t("loading") }}
                    </v-progress-circular>
                </v-overlay>
                <vue-custom-scrollbar
                    class="scroll-area"
                    style="height: calc(100vh - 100px)"
                    :settings="scrollbarSettings"
                    v-if="
                        summariesActive &&
                        activeReport.length &&
                        !activeReport.parent &&
                        !tableLoading
                    "
                >
                    <v-treeview
                        hoverable
                        transition
                        selected-color="rgb(130, 177, 255)"
                        class="treeview treeview__main"
                        :returnObject="true"
                        selectable
                        :items="getProfileItemsSources"
                        item-key="ind"
                        item-text="name"
                        item-children="items"
                        v-model="profilesManagement.selectionsSources"
                    >
                    </v-treeview>

                    <v-treeview
                        hoverable
                        transition
                        selected-color="rgb(130, 177, 255)"
                        class="treeview treeview__main"
                        :returnObject="true"
                        selectable
                        :items="getProfileItemsSubject"
                        item-key="ind"
                        item-text="name"
                        item-children="items"
                        v-model="profilesManagement.selectionsSubject"
                    >
                    </v-treeview>
                </vue-custom-scrollbar>
                <v-data-table
                    v-else-if="news.length && !summariesActive"
                    :headers="
                        topicsIsActive ? tableHeadersWithTopics : tableHeaders
                    "
                    :items="news"
                    :page.sync="pagination.current"
                    item-key="id"
                    show-select
                    v-model="selectedArticles"
                    @click:row="getSingleArticle"
                    class="elevation-1 fill-height fill-width news__list"
                    mobile-breakpoint="991"
                    show-expand
                    single-expand
                    :expanded="tableExpandedItem.data"
                >
                    <template v-slot:item.topicNewsCount="{ item }">
                        <button
                            class="d-flex align-center topics-btn"
                            v-if="item.topicNewsCount > 0"
                            @click.stop="openTopics(item.topic.topicNews)"
                        >
                            {{ item.topicNewsCount }}
                            <i class="ml-2 mt-1 d-flex align-center"
                                ><svg
                                    width="22"
                                    height="22"
                                    fill="#fff"
                                    viewBox="0 0 22 22"
                                >
                                    <use xlink:href="#plus-icon" /></svg
                            ></i>
                        </button>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td
                            :colspan="headers.length"
                            v-if="selectedArticlesContent"
                        >
                            <v-card-title
                                class="article__title"
                                v-if="selectedArticlesContent.title"
                            >
                                <a
                                    target="_blank"
                                    :href="selectedArticlesContent.uri"
                                    v-html="formated.title"
                                />
                            </v-card-title>
                            <v-select
                                v-if="selectedArticlesContent.subjects"
                                style="max-width: 82vw"
                                v-model="currCategorySelect"
                                :items="
                                    selectedArticlesContent.subjects.subject
                                "
                                @input="getCategorySelections"
                                item-text="name"
                                label="Выберите подсвечиваемый   тег"
                                item-value="name"
                                dense
                                outlined
                            ></v-select>
                            <v-card-text v-html="formated.text" />
                            <div class="article__closer">
                                <v-tooltip z-index="1000" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <button
                                            v-bind="attrs"
                                            v-on="on"
                                            class="article__closer-btn"
                                            @click="closeArticle"
                                        />
                                    </template>
                                    <span>{{
                                        $t("tooltips.closeArticle")
                                    }}</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </v-container>
            <v-container v-else style="display: flex; justify-content: center">
                Выберите отчет или сводку
            </v-container>
        </v-main>
        <v-dialog
            v-if="showElements.showAddReportsPopup"
            content-class="reports-popup"
            v-model="showElements.showAddReportsPopup"
            max-width="380"
        >
            <add-reports-popup
                v-on:popup_close="showElements.showAddReportsPopup = false"
                :screen="screen"
            />
        </v-dialog>
        <v-dialog
            v-if="showElements.showAddSummariesPopup"
            content-class="summaries-popup"
            v-model="showElements.showAddSummariesPopup"
            max-width="380"
        >
            <add-summaries-popup
                v-on:popup_close="showElements.showAddSummariesPopup = false"
                :screen="screen"
            />
        </v-dialog>
        <v-dialog
            v-if="showElements.showDownloadPopUp"
            v-model="showElements.showDownloadPopUp"
            :fullscreen="screen === 'mobile' ? true : false"
            max-width="750"
        >
            <download
                v-on:popup_close="showElements.showDownloadPopUp = false"
                :screen="screen"
                :scrlSet="scrollbarSettings"
                :activeItem="activeReport[0]"
                :date="currentDate"
            />
        </v-dialog>
        <v-dialog
            v-if="showElements.showSummaryTemplatePopUp"
            v-model="showElements.showSummaryTemplatePopUp"
            :fullscreen="screen === 'mobile' ? true : false"
            max-width="750"
        >
            <summary-template
                v-on:popup_close="showElements.showSummaryTemplatePopUp = false"
                :screen="screen"
                :scrlSet="scrollbarSettings"
                :activeItem="activeReport[0]"
                :date="currentDate"
                :digets="activeDigets"
                ref="sumTemplate"
                v-on:get_template="saveSummaryTemplate"
            />
        </v-dialog>
        <v-dialog
            v-if="showElements.showSavedSummaryPopup"
            content-class="reports-popup"
            v-model="showElements.showSavedSummaryPopup"
            max-width="520"
        >
            <v-card
                style="position: relative; height: 100%; background: #f5f5f5"
                class="addReport"
            >
                <v-toolbar
                    flat
                    dark
                    :class="screen === 'mobile' ? '' : 'pr-5 pl-5'"
                    color="#2196F3"
                    class="removePopupTitle"
                    style="padding: 0 10px !important"
                >
                    <v-toolbar-title>
                        {{ $t("modals.showSavedSummaryPopup.title") }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="showElements.showSavedSummaryPopup = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card style="padding: 0 10px">
                    <v-card-title
                        >{{ $t("modals.showSavedSummaryPopup.description") }}
                    </v-card-title>
                    <v-container class="remove-report-dialog">
                        <v-btn
                            color="#2196F3"
                            class="submit"
                            @click="showElements.showSavedSummaryPopup = false"
                            style="display: block; color: #fff"
                        >
                            OK
                        </v-btn>
                    </v-container>
                </v-card>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="showElements.showRemoveReportsPopup"
            content-class="reports-popup"
            v-model="showElements.showRemoveReportsPopup"
            max-width="520"
            v-on:keydown.enter="removeReports"
        >
            <v-card
                style="position: relative; height: 100%; background: #f5f5f5"
                class="addReport"
            >
                <v-toolbar
                    flat
                    dark
                    :class="screen === 'mobile' ? '' : 'pr-5 pl-5'"
                    color="#2196F3"
                    class="removePopupTitle"
                    style="padding: 0 10px !important"
                >
                    <v-toolbar-title>
                        {{
                            activeReport.length &&
                            activeReport[0].type === "report"
                                ? $t("modals.RemoveReportsPopup.title")
                                : $t("modals.RemoveReportsPopup.titleSummary")
                        }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="showElements.showRemoveReportsPopup = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card style="padding: 0 10px">
                    <v-card-title
                        >{{
                            activeReport.length &&
                            activeReport[0].type === "report"
                                ? $t("modals.RemoveReportsPopup.confirmation")
                                : $t(
                                      "modals.RemoveReportsPopup.confirmationSummary"
                                  )
                        }}
                        {{ activeReport[0].name }}?</v-card-title
                    >
                    <v-container class="remove-report-dialog">
                        <v-btn
                            color="#2196F3"
                            class="submit"
                            @click="removeReports"
                            style="display: block; color: #fff"
                        >
                            {{ $t("yes") }}
                        </v-btn>
                        <v-btn
                            color="#2196F3"
                            class="submit"
                            @click="showElements.showRemoveReportsPopup = false"
                            style="display: block; color: #fff"
                        >
                            {{ $t("no") }}
                        </v-btn>
                    </v-container>
                </v-card>
            </v-card>
        </v-dialog>
        <v-dialog
            v-if="showElements.showRenamePopup"
            content-class="rename-popup"
            v-model="showElements.showRenamePopup"
            max-width="380"
        >
            <v-card
                style="position: relative; height: 100%; background: #f5f5f5"
                class="rename-card"
            >
                <v-overlay
                    absolute
                    :opacity="0.5"
                    z-index="100000"
                    v-if="renameLoading"
                >
                    <v-progress-circular indeterminate size="64">
                        {{ $t("loading") }}
                    </v-progress-circular>
                </v-overlay>
                <v-form>
                    <v-toolbar
                        flat
                        dark
                        :class="screen === 'mobile' ? '' : 'pr-10 pl-10'"
                        color="#2196F3"
                        style="padding: 0 20px !important"
                    >
                        <v-toolbar-title>
                            {{
                                activeReport &&
                                activeReport[0].type === "report"
                                    ? $t("tooltips.renameReport")
                                    : $t("tooltips.renameSummary")
                            }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            dark
                            @click="showElements.showRenamePopup = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-container
                        class="pt-5"
                        :class="screen === 'mobile' ? '' : 'pr-15 pl-15 pt-0'"
                        style="padding: 5px 20px 0 !important"
                    >
                        <v-card flat style="background: transparent">
                            <v-card-subtitle class="renamePopup__subtitle"
                                >{{
                                    activeReport &&
                                    activeReport[0].type === "report"
                                        ? $t(
                                              "modals.RenamePopup.descriptionReport"
                                          )
                                        : $t(
                                              "modals.RenamePopup.descriptionSummary"
                                          )
                                }}
                                {{ activeReport[0].name }}</v-card-subtitle
                            >
                            <v-text-field
                                full-width
                                v-model="renameInput"
                                background-color="white"
                                class="text-input"
                                style="padding: 0 15px !important"
                                v-on:keydown.enter="renameReportOrSummary"
                            />
                            <v-row
                                dense
                                justify="end"
                                style="margin: 0; padding: 5px 15px 15px"
                            >
                                <v-btn
                                    color="#2196F3"
                                    class="submit"
                                    @click="renameReportOrSummary"
                                    style="
                                        display: block;
                                        color: #fff;
                                        margin-right: 20px;
                                    "
                                >
                                    {{ $t("yes") }}
                                </v-btn>
                                <v-btn
                                    color="#2196F3"
                                    class="submit"
                                    @click="
                                        showElements.showRenamePopup = false
                                    "
                                    style="display: block; color: #fff"
                                >
                                    {{ $t("no") }}
                                </v-btn>
                            </v-row>
                        </v-card>
                    </v-container>
                </v-form>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
import Download from "@/components/Download";
import UserSettings from "@/components/UserSettings";
import ReportsMenu from "@/components/ReportsMenu";
import Topics from "../components/Topics.vue";
import addReportsPopup from "@/components/addReportsPopup";
import addSummariesPopup from "@/components/addSummariesPopup";

import moment from "moment";
import SummaryTemplate from "../components/SummaryTemplate.vue";
export default {
    name: "Reports",
    components: {
        Download,
        UserSettings,
        Topics,
        ReportsMenu,
        addReportsPopup,
        addSummariesPopup,
        SummaryTemplate,
    },
    data: () => ({
        activeDigets: {},
        selectedNewsItemsSources: [],
        selectedNewsItemsSubject: [],
        renameInput: "",
        selectedSummaries: [],
        summariesActive: false,
        activeReport: [],
        renameLoading: false,
        tableLoading: false,
        menu: false,
        panelSettings: [0],
        topicsIsActive: true,
        scrollbarSettings: {
            suppressScrollY: false,
            suppressScrollX: false,
            wheelPropagation: false,
        },
        langs: [
            {
                key: "ru",
                label: "Русский",
            },
            {
                key: "en",
                label: "English",
            },
            {
                key: "az",
                label: "Azərbaycan",
            },
        ],
        nameRules: [
            (v) => !!v || "Введите Имя",
            (v) => v.length <= 15 || "Name must be less than 10 characters",
        ],
        valid: false,
        disableSend: false,
        tableExpandedItem: {
            isOpen: null,
            data: [],
        },
        treeviewOpenedElements: [],
        treeviewOpenedElements2: [],
        showElements: {
            showUserSettingsPopUp: false,
            showProfilePopUpAdd: false,
            showProfilePopUpRemove: false,
            showProfilePopUpRename: false,
            showProfilePopUp: false,
            showDownloadPopUp: false,
            showTopicsPupUp: false,
            showSearch: false,
            showDate: true,
            showTime: false,
            showDateMenu: false,
            showReloader: true,
            showAddReportsPopup: false,
            showRemoveReportsPopup: false,
            showAddSummariesPopup: false,
            showRenamePopup: false,
            showSavedSummaryPopup: false,
            showSummaryTemplatePopUp: false,
        },
        currCategorySelect: "",
        selectedArticles: [],
        selectedArticlesContent: "",
        selections: {
            categories: "",
            search: "",
        },
        selectionsRange: [],
        formated: {
            text: "",
        },
        drawer: null,
        currentLang: "ru",
        drawerRight: null,
        right: false,
        left: false,
        loaded: false,
        items: [],
        profiles: {
            current: "",
            list: [],
        },
        profilesManagement: {
            radioGroup: "",
            profileSettings: {
                sources: [],
                subjects: {
                    items: [],
                },
            },
            selectionsSubject: [],
            selectionsSources: [],
            addProfile: "",
            removeProfile: "",
            renameProfile: {
                newName: "",
                oldName: "",
            },
        },
        activeTopics: [],
        page: 1,
        pageCount: 1,
        searchValue: "",
        searchState: false,
        currentDate: {
            dateRangeText: ["00.00.00", "00.00.00"],
            firstDate: "",
            lastDate: "",
            firstTime: "00:00",
            lastTime: "23:59",
            today: "",
        },
        news: [],
        currNodeHash: "0",
        currArticleId: "",
        currentProcessingNode: 0,
        screen: "",
        snackbarFoundArticles: false,
        pagination: {
            current: 0,
        },
        highlightedLine: null,
        docTypes: {},
        oldSummary: {},
    }),
    props: ["source"],
    watch: {
        /**
         * apply highlight by chosen category selection (select in single article)
         * */
        selectedArticlesContent: function () {
            this.divideText(
                this.selectedArticlesContent.text,
                this.selectedArticlesContent.title
            );
        },
        selections: {
            handler() {
                this.divideText(
                    this.selectedArticlesContent.text,
                    this.selectedArticlesContent.title
                );
            },
            deep: true,
        },
        /**
         * apply chosen language
         * */
        currentLang: function () {
            this.$vuetify.lang.current = this.$store.state.lang = this.$i18n.locale = this.currentLang;
            localStorage.setItem("lang", this.$i18n.locale);
        },
    },

    created() {
        this.$store.commit("setWindowWidth");
        this.screen = this.$store.state.windowWidth;
    },
    async mounted() {
        this.$store.dispatch("getUserSettings");
        this.docTypes = await this.$store.dispatch("fetchDocTypes");
        this.$store.commit("startLoader");
        await this.$store.dispatch("GetReportNames");
        await this.$store.dispatch("GetSummariesNames");
        this.currentLang = this.$store.state.lang = this.$i18n.locale;
        localStorage.setItem("lang", this.$i18n.locale);
        /**
         * get initial date
         * */
        let currentDate = new Date();
        let startDate = this.$options.filters.date(
            new Date(currentDate.setDate(currentDate.getDate())),
            "DDMMYYYYhhmmss"
        );
        let endDate = this.$options.filters.date(
            new Date(currentDate),
            "DDMMYYYYhhmmss"
        );

        this.currentDate.dateRangeText = [
            endDate.split(", ")[0].split(".").reverse().join("-"),
        ];
        this.currentDate.firstDate = endDate.split(", ")[0];
        this.currentDate.lastDate = endDate.split(", ")[0];

        this.currentDate.today = this.currentDate.dateRangeText;
        /**
         * send request and get main treeview content
         * */
        this.loaded = true;
        this.$store.commit("stopLoader");
    },
    computed: {
        getSelectedArticles() {
            return this.$store.getters.selectedArticles;
        },
        /**
         * transform Source items from profile settings for treeview properly work
         * */
        getProfileItemsSources() {
            return this.mapProfileSettingsNodes([
                this.profilesManagement.profileSettings.sources,
            ]);
        },
        /**
         * transform Subject items from profile settings for treeview properly work
         * */
        getProfileItemsSubject() {
            return this.mapProfileSettingsNodes([
                this.profilesManagement.profileSettings.subjects.items,
            ]);
        },
        /**
         * remove selectable categories, which return from server with empty select range
         * */
        selectMarkableText() {
            if (!this.selectedArticlesContent) {
                return [];
            }
            /*let res = this.selectedArticlesContent.subjects.subject.filter(item => item.selections.selection)*/
            return this.selectedArticlesContent.subjects.subject;
        },
        /**
         * initialization v-data-table headers (watch vuetify documentation)
         * */
        tableHeadersWithTopics() {
            return [
                {
                    text: this.$t("data_table.topics"),
                    value: "topicNewsCount",
                    align: "center",
                    width: "90px",
                },
                {
                    text: this.$t("data_table.title"),
                    align: "start",
                    value: "title",
                    class: "title_td",
                },
                {
                    text: this.$t("data_table.publish_date"),
                    value: "publishDate",
                    width: "150px",
                },
                {
                    text: this.$t("data_table.source"),
                    value: "source",
                    width: "200px",
                },
                /* { text: this.$t("data_table.rate"), value: "rating" }, */
                {
                    text: this.$t("data_table.relevance"),
                    value: "relevance",
                    width: "121px",
                },
            ];
        },
        tableHeaders() {
            return [
                {
                    text: this.$t("data_table.title"),
                    align: "start",
                    value: "title",
                },
                {
                    text: this.$t("data_table.publish_date"),
                    value: "publishDate",
                },
                {
                    text: this.$t("data_table.source"),
                    value: "source",
                    width: "200px",
                },
                // { text: this.$t("data_table.rate"), value: "rating" },
                { text: this.$t("data_table.relevance"), value: "relevance" },
            ];
        },
        /**
         * transform date range for further request to server
         * */
        getDateRangeText() {
            let date = this.currentDate.dateRangeText.map((item) =>
                item.split("-").reverse().join(".")
            );
            this.currentDate.firstDate = date[0];
            this.currentDate.lastDate = date[1];
            let transform = (dateBefore) => {
                if (dateBefore) {
                    return [
                        ...dateBefore.slice(0, 6),
                        ...dateBefore.slice(8, 10),
                    ].join("");
                }
                return "";
            };
            let nextDate = this.currentDate.lastDate;
            if (this.currentDate.firstDate > this.currentDate.lastDate) {
                this.currentDate.lastDate = this.currentDate.firstDate;
                this.currentDate.firstDate = nextDate;
            }
            let transformData = [
                transform(this.currentDate.firstDate),
                transform(this.currentDate.lastDate),
            ].join(" - ");
            return transformData;
            /*
            let transformData = this.currentDate.dateRangeText.map(item => item.split('-').reverse().join('.'));
            this.currentDate.firstDate = transformData[0]
            this.currentDate.lastDate = transformData[1]
            return transformData.join('-')*/
        },
    },
    methods: {
        saveSummaryTemplate(el) {
            let data = {
                digestName: this.activeReport[0].name,
                minRelevance: el.minRelevance >= 0 ? el.minRelevance : 0,
                profile: this.transformProfileSettings(),
                TemplateID: el.id,
            };
            this.$store
                .dispatch("saveDigets", data)
                .then(() => {
                    this.profilesManagement.loading = false;
                })
                .then(() => {
                    this.fetchDocuments(this.activeReport);
                    return this.$toastr.success(
                        this.$t("messages.successfullySaved")
                    );
                });
        },
        /**
         * Добавление документов в отчет(документы выбираются на странице новости)
         *
         */
        addNewsToReport() {
            if (!this.activeReport && this.activeReport[0].type !== "report") {
                return this.$toastr.warning(this.$t("messages.selectArticles"));
            }
            let data = {
                reportName: this.activeReport[0].name,
                docIDs: this.getSelectedArticles.map((item) => {
                    return item.id;
                }),
            };
            this.$store.dispatch("addNewsToReport", data).then(() => {
                this.$store.commit("updateSelectedForDownload", {
                    selectedArticles: [],
                });
                setTimeout(() => {
                    this.fetchDocuments(this.activeReport);
                }, 200);
            });
        },
        filterAllProfileSettingsNodes(items) {
            return items.reduce((res, item) => {
                if (
                    !item.items ||
                    item.items.length === 0 ||
                    item.items === undefined ||
                    item.items === null
                ) {
                    return res.concat({
                        ind: item.ind,
                        id: item.id,
                        name: item.name,
                        checked: item.checked,
                    });
                } else {
                    return res.concat(
                        this.filterAllProfileSettingsNodes(item.items)
                    );
                }
            }, []);
        },
        transformProfileSettings() {
            let getAllId = (items) => {
                return items.reduce((res, item) => {
                    return res.concat(item.id);
                }, []);
            };
            let allSourcesNodes = this.mapProfileSettingsNodes([
                this.profilesManagement.profileSettings.sources,
            ]);
            let allSubjectNodes = this.mapProfileSettingsNodes([
                this.profilesManagement.profileSettings.subjects.items,
            ]);
            let allSourcesData = getAllId(
                this.filterAllProfileSettingsNodes(allSourcesNodes)
            );
            let allSubjectData = getAllId(
                this.filterAllProfileSettingsNodes(allSubjectNodes)
            );
            let sourcesData = getAllId(
                this.profilesManagement.selectionsSources
            );
            let subjectData = getAllId(
                this.profilesManagement.selectionsSubject
            );

            let uncheckedSources = allSourcesData.filter(function (id) {
                return !sourcesData.includes(id);
            });
            let uncheckedSubjects = allSubjectData.filter(function (id) {
                return !subjectData.includes(id);
            });
            let checkedSources = allSourcesData.filter(function (id) {
                return sourcesData.includes(id);
            });
            let checkedSubjects = allSubjectData.filter(function (id) {
                return subjectData.includes(id);
            });
            return {
                sources: uncheckedSources,
                objects: uncheckedSubjects,
                checkedSources: checkedSources,
                checkedSubjects: checkedSubjects,
            };
        },
        saveSummaryOptions() {
            if (this.activeReport.length && this.activeReport[0].parent) {
                return;
            }
            this.profilesManagement.loading = true;
            let activeID = this.docTypes.find((item) => {
                return item.name === this.activeDigets.templateName;
            });
            let data = {
                digestName: this.activeReport[0].name,
                minRelevance:
                    this.activeDigets.minRelevance >= 0
                        ? this.activeDigets.minRelevance
                        : 0,
                profile: this.transformProfileSettings(),
                TemplateID: activeID ? activeID.id : "30",
            };
            this.oldSummary[this.activeReport[0].name] = data;
            this.$store
                .dispatch("saveDigets", data)
                .then(() => {
                    this.profilesManagement.loading = false;
                    this.showElements.showSavedSummaryPopup = true;
                })
                .then(() => {
                    return this.$toastr.success(
                        this.$t("messages.successfullySaved")
                    );
                });
        },
        /**
         * Переименование выбранного отчета или выбранной сводки
         */
        renameReportOrSummary() {
            if (this.activeReport && this.activeReport[0].type === "report") {
                this.$store.dispatch("renameReport", {
                    oldName: this.activeReport[0].name,
                    newName: this.renameInput,
                });
                this.$store.dispatch("GetReportNames");

                this.showElements.showRenamePopup = false;
            } else if (
                this.activeReport &&
                this.activeReport[0].type === "summary"
            ) {
                this.$store
                    .dispatch("renameDigest", {
                        oldName: this.activeReport[0].name,
                        newName: this.renameInput,
                    })
                    .then(() => {
                        setTimeout(() => {
                            this.$store.dispatch("GetSummariesNames");
                        }, 1000);
                    });
                Object.defineProperty(
                    this.oldSummary,
                    this.renameInput,
                    Object.getOwnPropertyDescriptor(
                        this.oldSummary,
                        this.activeReport[0].name
                    )
                );
                delete this.oldSummary[this.activeReport[0].name];
                this.showElements.showRenamePopup = false;
            }
            this.activeReport[0].name = this.renameInput;
            this.renameInput = "";
        },
        /**
         * Открытие попапа для переименования отчета или сводки
         */
        renamePopup() {
            if (!this.activeReport.length || this.activeReport[0].parent) {
                return this.$toastr.warning(this.$t("messages.selectedItem"));
            }
            this.showElements.showRenamePopup = true;
        },
        /**
         * удаление выбранного документа(-ов) из выбранного отчета
         */
        removeDocument() {
            if (!this.selectedArticles.length) {
                return this.$toastr.warning(this.$t("messages.selectArticles"));
            }

            let arr = this.selectedArticles.map((item) => {
                return item.id;
            });
            let data = {
                reportName: this.$refs.repMenu.active[0].name,
                docIDs: arr,
            };
            this.$axios
                .post(
                    "http://core.memo.az/mainwindow/DeleteReportDocuments",
                    data
                )
                .then((res) => {
                    return res.data;
                })
                .finally(() => {
                    this.fetchDocuments(this.$refs.repMenu.active);
                });
        },
        /**
         * удаления выбранного отчета или выбранной сводки
         */
        removeReports() {
            if (this.activeReport[0].type === "report") {
                let data = {
                    reportName: this.activeReport[0].name,
                };
                this.$store.dispatch("DeleteReport", data).then(() => {
                    this.activeReport = [];
                });
            } else {
                let data = {
                    digestName: this.activeReport[0].name,
                };
                this.$store.dispatch("DeleteSummary", data).then(() => {
                    this.activeReport = [];
                });
            }
            this.showElements.showRemoveReportsPopup = false;
        },
        /**
         * запрос на получения документов в выбраном отчете или опций в выбранной сводке
         */
        fetchDocuments(item) {
            this.tableLoading = true;
            this.activeReport = item;
            if (item.length && item[0].parent) {
                this.tableLoading = false;
            } else {
                if (item[0] && item[0].type === "report") {
                    this.summariesActive = false;
                    this.$axios
                        .post(
                            " http://core.memo.az/mainwindow/GetReportDocuments ",
                            { reportName: item[0].name }
                        )
                        .then((res) => {
                            this.news = res.data.news;
                            this.news &&
                                this.news.forEach((article, index) => {
                                    let formatedDate = new Date(
                                        article.publishDate
                                    ).toLocaleDateString("ru-RU", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "numeric",
                                    });
                                    this.news[index].publishDate = formatedDate;
                                });
                        })
                        .finally(() => {
                            this.tableLoading = false;
                        });
                } else if (item[0] && item[0].type === "summary") {
                    this.summariesActive = true;
                    this.$axios
                        .post(
                            " http://core.memo.az/mainwindow/GetDigestSettings ",
                            { digestName: item[0].name }
                        )
                        .then((res) => {
                            this.activeDigets = res.data;
                            this.formatKeyInObg(
                                res.data.sources,
                                "sourceType",
                                "items",
                                this.$t("tooltips.newsSources")
                            );
                            this.formatKeyInObg(
                                res.data.subjects.items,
                                "subjects",
                                "items",
                                this.$t("tooltips.newsCategory")
                            );
                            this.profilesManagement.profileSettings =
                                res.data.profile;
                            this.profilesManagement.selectionsSources = this.filterCheckedProfileSettingsNodes(
                                this.mapProfileSettingsNodes([
                                    this.profilesManagement.profileSettings
                                        .sources,
                                ])
                            );
                            this.profilesManagement.selectionsSubject = this.filterCheckedProfileSettingsNodes(
                                this.mapProfileSettingsNodes([
                                    this.profilesManagement.profileSettings
                                        .subjects.items,
                                ])
                            );
                            let data = {
                                digestName: this.activeReport[0].name,
                                MinRelevance: "0",
                                profile: this.transformProfileSettings(),
                            };
                            this.oldSummary[this.activeReport[0].name] = data;
                        })
                        .finally(() => {
                            this.tableLoading = false;
                        });
                } else {
                    return;
                }
            }
        },
        /**
         * transform data which return from profile settings request
         * */
        formatKeyInObg(object, prev_key, next_key, name_key_value) {
            const RENAME_KEY = (obj, old_key, new_key) => {
                if (obj[old_key]) {
                    Object.defineProperty(
                        obj,
                        new_key,
                        Object.getOwnPropertyDescriptor(obj, old_key)
                    );
                    delete obj[old_key];
                }
                return obj;
            };
            object.name = name_key_value;
            object.id = `${name_key_value}_1`;
            return RENAME_KEY(object, prev_key, next_key);
        },
        filterCheckedProfileSettingsNodes(items) {
            return items.reduce((res, item) => {
                if (item.items.length === 0) {
                    if (item.checked === "true") {
                        return res.concat({
                            ind: item.ind,
                            id: item.id,
                            name: item.name,
                            checked: item.checked,
                        });
                    }
                } else {
                    if (item.checked !== "false") {
                        return res.concat(
                            this.filterCheckedProfileSettingsNodes(item.items)
                        );
                    }
                }
                return res;
            }, []);
        },
        /**
         * transform profile settings which came from server for treeview
         * */
        mapProfileSettingsNodes(items, i = 0) {
            return items.map((item, index) => {
                return {
                    ind: `${index}_${i}`,
                    id: item.id,
                    name: item.name,
                    checked: item.checked,
                    items: item.items
                        ? this.mapProfileSettingsNodes(
                              item.items,
                              `${index}_${i + 1}`
                          )
                        : [],
                };
            });
        },
        /**
         * anable topic column in data-table
         * */
        changeTopicActivation(isActive) {
            isActive
                ? (this.topicsIsActive = true)
                : (this.topicsIsActive = false);
        },
        openAddReportsPopup() {
            return (this.showElements.showAddReportsPopup = true);
        },
        openAddSummariesPopup() {
            return (this.showElements.showAddSummariesPopup = true);
        },
        openRemoveReportsPopup() {
            if (!this.activeReport.length || this.activeReport[0].parent) {
                return this.$toastr.warning(this.$t("messages.selectedItem"));
            }
            return (this.showElements.showRemoveReportsPopup = true);
        },
        download(data) {
            let downloadedTemplate = this.docTypes.find((item) => {
                return item.name === this.activeDigets.templateName;
            });
            let today = new Date().toLocaleDateString("ru-RU", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            });
            let date = today.split(", ")[0];
            let time = today.split(", ")[1];
            let transformDate = date
                .split(".")
                .splice(0, 2)
                .concat(
                    today
                        .split(", ")[0]
                        .split(".")
                        [today.split(", ")[0].split(".").length - 1].split("")
                        .splice(2)
                        .join("")
                )
                .join(".");
            let transformTime = time.split(":").splice(0, 2).join(":");

            let transformed = `${transformDate}(${transformTime})`;

            let name = this.activeReport[0]
                ? `${this.activeReport[0].name}_${transformed}`
                : `Export_${transformed}`;
            let type = downloadedTemplate.name.split(".")[1];
            let fileName = `${name}.${type}`;
            let element = document.createElement("a");
            element.setAttribute(
                "href",
                "data:text/html;base64;charset=utf-8," +
                    encodeURIComponent(data)
            );
            element.setAttribute("download", fileName);

            element.style.display = "none";
            document.body.appendChild(element);

            element.click();

            this.$toastr.success(
                `${name} ${this.$t("messages.successfullySaved")}`
            );
            document.body.removeChild(element);
            this.$store.commit("stopLoader");
        },
        async openDownloadPopup() {
            if (this.activeReport.length) {
                let getAllId = (items) => {
                    return items.reduce((res, item) => {
                        return res.concat(item.id);
                    }, []);
                };
                if (this.activeReport[0].type === "summary") {
                    if (!this.profilesManagement.selectionsSources.length) {
                        return this.$toastr.warning(this.$t("alerts.alert4"));
                    }
                    if (!this.profilesManagement.selectionsSubject.length) {
                        return this.$toastr.warning(this.$t("alerts.alert3"));
                    }

                    let check = (a, b) => {
                        if (a.length === b.length) {
                            return a.every((item) => {
                                return b.includes(item);
                            });
                        }
                        return false;
                    };
                    if (
                        !check(
                            getAllId(this.profilesManagement.selectionsSources),
                            this.oldSummary[this.activeReport[0].name].profile
                                .checkedSources
                        ) ||
                        !check(
                            getAllId(this.profilesManagement.selectionsSubject),
                            this.oldSummary[this.activeReport[0].name].profile
                                .checkedSubjects
                        )
                    ) {
                        return this.$toastr.warning(this.$t("alerts.alert2"));
                    }
                    if (!this.activeDigets.templateName) {
                        return this.$toastr.warning(this.$t("alerts.alert1"));
                    }
                    this.$store.commit("startLoader");

                    let obj = {
                        digestName: this.activeReport[0].name,
                        startDate: `${this.currentDate.firstDate}, ${this.currentDate.firstTime}:00`,
                        endDate: `${
                            this.currentDate.lastDate
                                ? this.currentDate.lastDate
                                : this.currentDate.firstDate
                        }, ${this.currentDate.lastTime}:00`,
                        templateID: this.docTypes.find((item) => {
                            return item.name === this.activeDigets.templateName;
                        }).id,
                    };
                    this.documentData = await this.$store
                        .dispatch("downloadDigets", obj)
                        .then((item) => {
                            if (item == "AA==" || typeof item === "function") {
                                this.$store.commit("stopLoader");

                                return this.$toastr.warning(
                                    this.$t("alerts.alert5")
                                );
                            }
                            this.download(item);
                        });
                    return;
                }

                return (this.showElements.showDownloadPopUp = true);
            }
            return this.$toastr.warning(this.$t("messages.selectArticles2"));
        },
        /**
         * exit btn action
         * */
        exit() {
            localStorage.removeItem("hash");
            this.$router.push("/");
        },
        /**
         * transform time from 00:00 format to 00:00:00 for request
         * */
        transformTime(time) {
            let tempTime;
            tempTime = time.split(":").concat(["00"]).join(":");
            return tempTime;
        },
        /**
         * clean all selected topics or news
         * */
        cleanDownloadStore() {
            this.$store.commit("updateSelectedForDownload", {
                selectedArticles: [],
                selectedTopics: [],
            });
            this.selectedArticles = [];
        },
        /**
         * validate search date range
         * */
        dateValidation() {
            let start;
            let end;
            const DATE_FORMAT = (date) => {
                return date;
            };
            if (this.currentDate.dateRangeText.length === 1) {
                if (
                    this.showElements.showTime &&
                    this.currentDate.firstTime &&
                    this.currentDate.lastTime
                ) {
                    start = `${DATE_FORMAT(
                        this.currentDate.firstDate
                    )}, ${this.transformTime(this.currentDate.firstTime)}`;
                    end = `${DATE_FORMAT(
                        this.currentDate.firstDate
                    )}, ${this.transformTime(this.currentDate.lastTime)}`;
                    return [start, end];
                } else {
                    start = `${DATE_FORMAT(
                        this.currentDate.firstDate
                    )}, 00:00:00`;
                    end = `${DATE_FORMAT(
                        this.currentDate.firstDate
                    )}, 23:59:59`;
                    return [start, end];
                }
            } else {
                //transform for moment js
                let currFirstDate = this.currentDate.firstDate
                    .split(".")
                    .reverse()
                    .join(".");
                let currLastDate = this.currentDate.lastDate
                    .split(".")
                    .reverse()
                    .join(".");
                if (
                    moment(currFirstDate, "YYYY.MM.DD") <
                    moment(currLastDate, "YYYY.MM.DD")
                ) {
                    console.log(moment(currFirstDate, "YYYY.MM.DD"));

                    if (
                        this.showElements.showTime &&
                        this.currentDate.firstTime &&
                        this.currentDate.lastTime
                    ) {
                        start = `${DATE_FORMAT(
                            this.currentDate.firstDate
                        )}, ${this.transformTime(this.currentDate.firstTime)}`;
                        end = `${DATE_FORMAT(
                            this.currentDate.lastDate
                        )}, ${this.transformTime(this.currentDate.lastTime)}`;
                        return [start, end];
                    } else {
                        start = `${DATE_FORMAT(
                            this.currentDate.firstDate
                        )}, 00:00:00`;
                        end = `${DATE_FORMAT(
                            this.currentDate.lastDate
                        )}, 23:59:59`;
                        return [start, end];
                    }
                } else {
                    if (
                        this.showElements.showTime &&
                        this.currentDate.firstTime &&
                        this.currentDate.lastTime
                    ) {
                        start = `${DATE_FORMAT(
                            this.currentDate.lastDate
                        )}, ${this.transformTime(this.currentDate.firstTime)}`;
                        end = `${DATE_FORMAT(
                            this.currentDate.firstDate
                        )}, ${this.transformTime(this.currentDate.lastTime)}`;
                        return [start, end];
                    } else {
                        start = `${DATE_FORMAT(
                            this.currentDate.lastDate
                        )}, 00:00:00`;
                        end = `${DATE_FORMAT(
                            this.currentDate.firstDate
                        )}, 23:59:59`;
                        return [start, end];
                    }
                }
            }
        },

        /**
         * count figure of found articles
         * */
        countOfFoundArticles() {
            if (this.items[0]) {
                let arrOfCategories = this.items[0].children.childs;
                return arrOfCategories.reduce((acc, categ) => {
                    return acc + categ.newsCount;
                }, 0);
            }
            return 0;
        },

        /**
         * send search request after click on reload btn
         * */
        searchSubmit() {
            let searchValue = this.searchValue;
            let startDate = this.dateValidation()[0];
            let endDate = this.dateValidation()[1];
            this.currNodeHash = "";
            this.searchState = true;
            this.news = [];
            this.items = [];
            if (searchValue) {
                let sendData = {
                    query: searchValue,
                    startDate: startDate,
                    endDate: endDate,
                };
                this.$store.commit("startLoader");
                this.$axios
                    .post(
                        "http://core.memo.az/mainwindow/getnewstreebyquery",
                        sendData
                    )
                    .then((res) => {
                        if (res.data.childrenCount) {
                            this.items.push(res.data);
                            this.treeviewOpenedElements.push(
                                res.data,
                                res.data.children.childs[0]
                            );
                        }
                    })
                    .finally(() => {
                        this.loaded = true;
                        this.$store.commit("stopLoader");
                    });
            } else {
                this.fetchDocuments();
            }
        },
        /**
         * divide text for properly highlight on search and category selections
         * */
        divideText(text, title) {
            if (!text) {
                return;
            }
            let res = [];
            let innerText = text;
            let innerTitle = title;
            this.selectionsRange = [];

            //put in selectionsRange search and categories ranges with including type key
            if (
                this.selections.search.length !== 0 &&
                this.selections.categories.selection
            ) {
                this.selections.search.forEach((s) => {
                    s.type = "search";
                    this.selectionsRange.push(s);
                });
                this.selections.categories.selection.forEach((s) => {
                    s.type = "category";
                    this.selectionsRange.push(s);
                });
            } else if (
                this.selections.search.length === 0 &&
                this.selections.categories.selection
            ) {
                this.selections.categories.selection.forEach((s) => {
                    s.type = "category";
                    this.selectionsRange.push(s);
                });
            } else if (
                this.selections.search.length !== 0 &&
                !this.selections.categories.selection
            ) {
                this.selections.search.forEach((s) => {
                    s.type = "search";
                    this.selectionsRange.push(s);
                });
            }

            if (this.selectionsRange.length !== 0) {
                let ranges = this.selectionsRange;
                let selectText = ranges.reduce((accum, range) => {
                    let { start, length, type } = range;
                    let markedText = {};
                    markedText.type = type;
                    if (type === "search") {
                        if (title.length > +start) {
                            markedText.text = title.substring(
                                +start,
                                +start + +length
                            );
                        } else {
                            markedText.text = text.substring(
                                +start - (title.length + 1),
                                +start - (title.length + 1) + +length
                            );
                        }
                    } else {
                        if (title.length > +start) {
                            markedText.text = title.substring(
                                +start,
                                +start + +length
                            );
                        } else {
                            markedText.text = text.substring(
                                +start - (title.length + 1),
                                +start - (title.length + 1) + +length
                            );
                        }
                    }
                    return accum.concat(markedText);
                }, []);

                selectText.forEach((selection) => {
                    if (selection.type === "category") {
                        if (innerTitle.includes(selection.text)) {
                            innerTitle = innerTitle.replace(
                                selection.text,
                                `<mark style="color: #fff; background: #1976d2;">${selection.text}</mark>`
                            );
                        } else {
                            innerText = innerText.replace(
                                selection.text,
                                `<mark style="color: #fff; background: #1976d2;">${selection.text}</mark>`
                            );
                        }
                    }
                });
                selectText.forEach((selection) => {
                    if (selection.type === "search" && selection.text !== "") {
                        innerTitle = innerTitle.replaceAll(
                            selection.text,
                            `<mark style="color: #4e4e4e; background: #ffdc91;">${selection.text}</mark>`
                        );
                        innerText = innerText.replaceAll(
                            selection.text,
                            `<mark style="color: #4e4e4e; background: #ffdc91;">${selection.text}</mark>`
                        );
                    }
                });
            }
            innerText.split("\r").forEach((p) => {
                res.push(`${p}</br>`);
            });
            this.formated.title = innerTitle;
            this.formated.text = res.join("");
            return;
        },
        /**
         * close all articles
         * */
        closeArticle() {
            this.tableExpandedItem.isOpen = null;
            this.selectedArticlesContent = "";
            this.currArticleId = "";
        },
        /**
         * request which get sigle article on v-data-table row extention
         * */
        async getSingleArticle(e) {
            if (this.tableExpandedItem.isOpen === e.id) {
                this.tableExpandedItem.data = [];
                this.tableExpandedItem.isOpen = null;
                this.selectedArticlesContent = "";
                this.currArticleId = "";
                return;
            }
            this.$store.commit("startLoader");
            this.loading = true;
            this.selectedArticlesContent = "";
            this.currArticleId = e.id;
            let sendData = {
                TextID: e.id,
            };
            await this.$axios
                .post(
                    "http://core.memo.az/mainwindow/GetNewsText",
                    sendData
                )
                .then((res) => {
                    this.loading = false;
                    this.$store.commit("stopLoader");
                    this.selections.categories = "";
                    this.selections.search = "";
                    this.selectedArticlesContent = res.data;
                    if (res.data.querySelections) {
                        this.selections.search =
                            res.data.querySelections.querySelection;
                    }
                    this.tableExpandedItem.data = [res.data];
                    this.tableExpandedItem.isOpen = e.id;
                    this.tableExpandedItem.data[0].id = e.id;
                    if (res.data.subjects) {
                        this.selections.categories =
                            res.data.subjects.subject[0].selections;
                        this.currCategorySelect =
                            res.data.subjects.subject[0].name;
                    }
                })
                .finally(() => (this.loaded = true));
        },
        closeDatePicker() {
            this.showElements.showDate = false;
        },
        /**
         * open Topics popup
         * */
        openTopics(data) {
            this.activeTopics = data;
            this.showElements.showTopicsPupUp = true;
        },
    },
};
</script>
<style lang="scss">
.reports-and-summaries {
    .remove-report-dialog {
        margin: 0;
        padding: 10px 10px 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .v-btn {
            margin: 0 10px;
        }
    }
    .title_td {
        min-width: 300px;
    }

    .treeview__main .v-treeview-node__level {
        display: none !important;
    }

    .treeview__main-scroll {
        @media (max-width: 1280px) {
            height: calc(100vh - 175px) !important;
        }
    }

    .expansion-is-open {
        .treeview__main-scroll {
            @media (max-width: 1280px) {
                height: calc(100vh - 260px) !important;
            }
        }
    }

    .news__list tr {
        cursor: pointer;
    }

    .news__list th span {
        white-space: nowrap;
    }

    .vuetify__select {
        max-width: 260px;
    }

    .v-data-table__expand-icon {
        pointer-events: none;
    }

    .v-treeview-node__label {
        font-size: 12px !important;
        white-space: pre-wrap !important;
    }

    .fill-width {
        width: 100%;
    }
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        padding: 0 8px !important;
    }
    .v-data-table-header {
        th {
            padding: 0 8px !important;
        }
        & th:nth-child(3) {
            min-width: 85px !important;
        }

        & th:nth-child(4) {
            min-width: 300px;
        }

        & th:nth-child(5) {
            min-width: 120px;
        }

        & th:nth-child(6) {
            min-width: 200px;
        }

        & th:nth-child(7) {
            min-width: 140px;
        }
    }

    [aria-expanded="true"] > .v-treeview-node__root {
        background: #f3f3f3;
        filter: grayscale(100%);
    }

    .is-disabled {
        filter: grayscale(0) !important;
    }

    .is-active {
        background: #ffdc91 !important;
        filter: grayscale(0) !important;
    }

    .v-treeview-node--leaf .is-active {
        pointer-events: none;
    }

    .v-card__text a {
        word-break: break-all;
    }

    .v-card__title {
        word-break: normal;
    }

    .treeview__activator {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .v-treeview-node__label span {
        color: rgba(0, 0, 0, 0.87) !important;
    }

    .v-menu__content {
        background: #fff;
    }

    .article__title {
        & a {
            text-decoration: none;
            transition: opacity 0.2s ease;

            &:hover {
                opacity: 0.7;
            }
        }
    }

    .v-data-table__mobile-row {
        min-width: 90vw;
        max-width: 90vw !important;
    }

    .v-sheet.v-snack__wrapper:not(.v-sheet--outlined) {
        max-width: max-content;
        min-width: 200px;
    }

    @media (max-width: 767px) {
        .v-data-table__expanded td {
            max-width: 90vw !important;
        }
        .v-data-table__wrapper {
            max-width: 90vw !important;
        }
        .v-data-table__mobile-table-row {
            display: block !important;
        }

        .v-data-table__wrapper tbody {
            display: flex !important;
            flex-direction: column !important;
        }
    }

    .v-card__text img {
        max-width: 20%;
    }

    .input-date {
        max-width: 170px;
    }

    .input-date .v-icon,
    .lastTime .v-icon {
        font-size: 14px;
    }

    //component styles

    .select--lang {
        text-transform: uppercase;
        max-width: 50px;
    }

    .profile {
        &__card {
            overflow: hidden;

            &-title {
                color: #757575;
                border-bottom: 1px solid #e8e8e8;
            }
        }
    }

    .scroll-area {
        position: relative;
        margin: auto;
        height: 195px;
    }

    .search_input {
        max-width: 200px;
        @media (max-width: 1500px) {
            max-width: 150px;
        }
    }

    .ps__thumb-x,
    .ps__thumb-y {
        background-color: #2196f3;
    }

    .ps__rail-y.ps--clicking .ps__thumb-y,
    .ps__rail-y:focus > .ps__thumb-y,
    .ps__rail-y:hover > .ps__thumb-y {
        background-color: #2196f3;
    }

    /*.lastTime, .firstTime{
  filter: brightness(0) invert(1);
}*/

    /*margins*/

    @media (max-width: 1500px) {
        .v-application .ml-3 {
            margin-left: 8px !important;
        }
        .v-application .mr-3 {
            margin-right: 8px !important;
        }
    }

    /*appearance on different sizes*/

    .select--lang {
        & .v-select__selections {
            max-width: min-content;
        }

        & .v-input__append-inner {
            margin: 0 !important;
            padding: 0 !important;
        }
    }

    .profiles__btns {
        & .v-toolbar__content {
            @media (max-width: 1359px) {
                width: 100%;
            }
        }
    }

    .popup__card {
        @media (max-width: 480px) {
            min-width: 100%;
        }
    }

    .search_input ~ button i:before {
        color: #ffdc91;
    }

    //transition

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .drawer__header {
        .btn--stroke {
            border-color: #2196f3;
        }
        .v-input__slot {
            &::before {
                border-color: #2196f3 !important;
            }
        }
        .v-select__selection {
            color: #2196f3 !important;
        }
        .v-select__slot {
            label {
                color: #2196f3;
            }
        }
        .v-icon {
            svg {
                fill: #2196f3;
            }
        }
    }

    .profile {
        form {
            background: #fff;
        }
        .v-input--selection-controls__input {
            display: none;
        }
        .v-radio {
            &.v-item--active,
            &:hover {
                background: #e3f3ff;
            }
        }
    }

    .settings-expand {
        .v-expansion-panel-header {
            padding: 0;
            min-height: unset !important;
        }
        .v-expansion-panel-header__icon {
            margin: 0 auto;
        }
        .v-expansion-panel-content__wrap {
            padding: 0;
        }
        .v-expansion-panel-header .v-icon {
            position: relative;
            font-size: 0 !important;
            height: 20px;
            &::before {
                content: "";
                border-top: 7px solid #2196f3;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
            }
        }
    }

    .article__closer {
        display: flex;
        justify-content: flex-end;
        margin-top: -50px;
        &-btn {
            position: relative;
            margin-right: -14px;
            height: 50px;
            width: 50px;
            border-radius: 50%;
            transition: all 0.2s ease;
            outline: none;
            &:hover {
                background: #2196f3;
            }
            &::before {
                position: absolute;
                content: "";
                top: 50%;
                left: 50%;
                width: 9px;
                height: 9px;
                border-bottom: 2px solid rgba(0, 0, 0, 0.54);
                border-left: 2px solid rgba(0, 0, 0, 0.54);
                transform: translate(-50%, -50%) rotate(135deg);
            }
        }
    }
    .topics-btn {
        margin: 0 auto;
        svg {
            fill: #757575;
            stroke: #757575;
        }
        &:hover {
            fill: rgb(33, 150, 243);
            stroke: rgb(33, 150, 243);
        }
    }

    .user-settings-popup {
        @media (max-width: 767px) {
            .v-data-table__wrapper,
            .v-data-table__expanded td,
            .v-data-table__mobile-row {
                max-width: 100vw !important;
            }
            .v-data-table-header-mobile__wrapper .v-select {
                max-width: 65%;
            }
        }
    }

    .v-data-table-header th[style="width: 110px; min-width: 110px;"] {
        white-space: nowrap;
    }
}
</style>
